import { ViewFilters } from "web/components"
import { useState } from "react"
import { TileSizeSelectors } from "web/components/Tiles"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"
import { Input } from "web/components/Form/Controls"
import { isNonEmptyArray } from "web/services/helpers"

export function TileMapSettingsModal({
  backButtonHandler,
  close,
  overview,
  tile,
  tileEntry,
}) {
  const [title, setTitle] = useState({ value: tile.name })

  const [tileWidth, setTileWidth] = useState({
    value: tileEntry.width,
  })
  const [tileHeight, setTileHeight] = useState({
    value: tileEntry.height,
  })

  async function handleSave() {
    if (
      tileEntry.height !== tileHeight.value ||
      tileEntry.width !== tileWidth.value
    ) {
      await overview.update({
        [overview.type]: {
          tile_entries_attributes: [
            {
              id: tileEntry.id,
              height: tileHeight.value,
              width: tileWidth.value,
            },
          ],
        },
      })
    }

    if (title && title.value && /\S/.test(title.value)) {
      await tile.update({
        overview_tile: {
          name: title.value.trim(),
        },
      })
    }

    close()
  }

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="mb-4 flex items-end">
          <Input label="Title" value={title} onChange={setTitle} />
        </div>
        <div>
          <TileSizeSelectors
            tileWidth={tileWidth}
            tileHeight={tileHeight}
            setTileHeight={setTileHeight}
            setTileWidth={setTileWidth}
            limitTileSizeOptions={{ width: 2, height: 2 }}
          />
        </div>
        {isNonEmptyArray(tile.available_fields) && (
          <div className="mb-6 mt-6 rounded-md border px-4 py-4 shadow-sm">
            <div className="mb-1 text-lg font-bold">Filters</div>
            {overview.type === "viewable" && (
              <div className="text-sm italic">
                Filters applied to this map will override the existing filter(s)
                currently applied to your Overview
              </div>
            )}
            <div className="mb-3">
              <ViewFilters
                availableFields={tile.available_fields}
                containerClasses="my-2 md:my-3"
                filterConditions={tile.conditions}
                handleAddCondition={(conditionToAdd) =>
                  tile.handleAddCondition(conditionToAdd, tile.data)
                }
                handleChangeCondition={(condition, updatedConditionValue) =>
                  tile.handleChangeCondition({
                    condition,
                    updatedConditionValue,
                  })
                }
                handleDeleteCondition={(condition) =>
                  tile.handleDeleteCondition(condition)
                }
                handleAddFieldToConditions={(field) =>
                  tile.handleAddFieldToConditions(field)
                }
                subjectType={tile.tile_fields_subject_type}
                topicId={tile.topic?.id}
              />
            </div>
          </div>
        )}
      </div>
      <TileWizardActions
        onSaveHandler={handleSave}
        backButtonHandler={backButtonHandler}
      />
    </>
  )
}
